import { Subject } from "rxjs";
import { OENRateSubscriptionState } from "../../enums/oe-rate-subscription-state.enum";
import { OERateTransportModel } from "./oe-rate-transport.model";

export class OEOutgoingRateSubscriptionModel {
  public subscrKey: string = null; // ccyPair +
  public state: OENRateSubscriptionState = OENRateSubscriptionState.ACTIVE; // AUG: to be replaced with enum
  public refIds: Array<string> = new Array<string>();
  public ccyPair: string = null;
  public invertedCcyPair: string = null;

  private _subject: Subject<OERateTransportModel>;

  public get subject() {
    return this._subject;
  }

  public set subject(subject: Subject<OERateTransportModel>) {
    this._subject = subject;
  }

  constructor(subscrKey: string) {
    this.subscrKey = subscrKey;
  }
}
